import type { FC } from 'react'
import { InputAdornment } from '@mui/material'
import { tss } from '@dhl/theme'
import { Close } from '@dhl/icons'

interface Props {
  visible?: boolean
}

const useStyles = tss.makeStyles()((theme) => ({
  adornment: {
    '&.MuiInputAdornment-positionEnd': {
      marginRight: 6,
    },
  },
  icon: {
    fontSize: '1.2rem',
    color: theme.palette.error.main,
  },
}))

export const ErrorInputAdornment: FC<Props> = ({ visible }) => {
  const { classes } = useStyles()

  if (!visible) {
    return null
  }

  return (
    <InputAdornment className={classes.adornment} position="end">
      <Close className={classes.icon} />
    </InputAdornment>
  )
}
